module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "forewordPage"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Lord Buckley’s apothegm on the life of Christ was this: “When the Naz laid it down, it stayed down.” So have we always said about J.J. Johnston. The we, of which I am proud to be a part, is that group of writers, show folk and general neer-do-wells who came together in the Chicago of the late ‘60s. We knew J.J., initially, as an actor and raconteur; it took some longer acquaintance to recognize in him the best of historians.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In his allied areas of expertise—American Crime and American Boxing—his interlocutors have yet to find him at a loss.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Ask who was the Bartender at Little Bohemia, or who was Terry McGovern’s favorite cut man, and you get not only an immediate answer, but a correction, and midrash. “The books say X, but it was really Y, and let me tell you a story about that….” This guy is the real McCoy, and let me tell you a story about that. I was asked to write a film about John Dillinger, so I called up J.J. “I’m going to a meeting,” I said, “Would you come along and front for me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("He of course said of course, and off we went to the Bel Air Hotel, there to meet several adolescent moguls. J.J. showed up with some WANTED posters, which he put on the table, and a rumpled paper bag, which he put at his feet. The posters were original, desiring the whereabouts of Alvin Karpis, Pretty Boy Floyd, Dillinger, Baby Face Nelson, et cetera.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("J.J. held the breakfast meeting entranced until two in the afternoon, when the young things decided to migrate back to work.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("One of them, on rising, said, “You know, Dillnger’s looks changed drastically in the last months of his life. After that plastic surgery. In fact, they took a death mask of him, showing the remarkable discrepancy. They made two. One is at the F.B.I. building, in Washington, and I don’t know where the other one is.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“It’s right here,” J.J. said, and produced it from the paper bag at his feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("This boxing book similarly, and in the highest praise of our Chicago coterie, is The Real Deal.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I read it and hear his inimitable voice laying it down. I’m sure you will, too; I wish you could hear him in person.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-br"
  }, [_c('span', [_c('br'), _vm._v(" David Mamet "), _c('br'), _vm._v("June 8, 2004")])])])]), _c('a', {
    attrs: {
      "id": "title1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad9dea90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439614785_frw01.vue
// module id = 78
// module chunks = 0